export default __webpack_public_path__ + "static/Multichain-549a4f5e8b5cdc45669a94ef8581c1ee.png";